import { ChangeDetectorRef, Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { PartnerResolver } from "../../partner/models/partner-resolver";
import { UntypedFormGroup, FormsModule } from "@angular/forms";
import { distinctUntilChanged } from "rxjs/operators";

import { DataFieldGroupContainerComponent } from "../../shared/datafields/datafield-group-container.component";

@Component({
    selector: 'app-developer-partner-fallback-resolver-config',
    templateUrl: './developer-partner-fallback-resolver-config.component.html',
    styleUrls: ['./developer-partner-fallback-resolver-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, DataFieldGroupContainerComponent]
})
export class DeveloperPartnerFallbackResolverConfigComponent {

    @Input() partnerResolver: PartnerResolver;

    formGroup: UntypedFormGroup = new UntypedFormGroup({});

    showConfiguration: boolean = false;
    isFormValid: boolean = false;

    constructor(private cdr: ChangeDetectorRef) {
        this.isFormValid = this.formGroup.valid;
        this.formGroup.statusChanges
        .pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)))
        .subscribe(
            result => {
                this.isFormValid = (result === 'VALID');
                this.cdr.detectChanges();
            }
        );
    }
}